<template>
  <div>
    <el-row :gutter="10" class="row-bg">
      <!-- 第一行：关键词 / 公司 / 部门 / 时间范围 -->
      <el-col :span="5" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="单据号/用途/收款方" @keyup.enter="fetch"
            clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="7" :xs="24">
        <el-form-item label="申请公司">
          <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="companyChange"
            check-strictly :render-after-expand="false" placeholder="请选择公司" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="5" :xs="24">
        <el-form-item label="申请部门">
          <el-tree-select ref="departments" v-model="paramsObj.departmentId" :data="departments" @change="fetch"
            check-strictly :render-after-expand="false" clearable placeholder="请选择部门" style="width:100%" />
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-form-item label="时间范围">
          <el-date-picker v-model="valueTime" type="daterange" @calendar-change="fetch" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
            :shortcuts="$util.getShortCuts()" size="default" style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-col>

      <!-- 第二行：收款方 / 业务类型 / 申请人 / 确认 -->
      <el-col :span="5" :xs="24">
        <el-form-item label="收款方">
          <el-input v-model="paramsObj.payee" placeholder="供应商/收款方名称" @keyup.enter="fetch" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-form-item label="业务类型">
          <el-select v-model="paramsObj.formName" placeholder="全部" size="default" @change="fetch" clearable
            style="width:100%">
            <el-option v-for="item in formNames" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-form-item label="申请人">
          <el-input v-model="paramsObj.applyUser" placeholder="申请人姓名" @keyup.enter="fetch" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="7" :xs="24">
        <el-button size="default" type="primary" @click="fetch"> 确认 </el-button>
      </el-col>
    </el-row>

    <el-row type="flex" :gutter="20">
      <el-col :span="24" :xs="24">
        <h4 style="margin:10px auto; text-align: left;">周期内OA费用单据按收款方(供应商)汇总（点击行首箭头展开单据明细）</h4>
        <el-table class="table" :data="supplierData" border size="small" style="margin:0 auto">
          <el-table-column type="expand">
            <template #default="props">
              <div style="padding: 5px 40px;">
                <h4 style="margin:8px auto; text-align: left;">单据明细</h4>
                <el-table :data="getDetailRows(props.row.payee)" border size="small">
                  <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
                  <el-table-column prop="billCode" label="单据号" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="formName" label="业务类型" width="110" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="transferType" label="转账方式" width="80" align="center"> </el-table-column>
                  <el-table-column prop="billDate" label="日期" width="100" sortable align="center">
                    <template #default="scope">{{ $util.fmtDate(scope.row.billDate, "yyyy/MM/dd") }}</template>
                  </el-table-column>
                  <el-table-column prop="billStatus" label="请款单状态" width="110" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="payStatus" label="付款状态" width="90" align="center">
                    <template #default="scope">
                      <el-tag :type="scope.row.payStatus === '已付款' ? 'success' : 'warning'" size="small">
                        {{ scope.row.payStatus }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="billFee" label="请款金额" width="110" sortable align="right">
                    <template #default="scope">{{ $util.fmtMoney(scope.row.billFee) }}</template>
                  </el-table-column>
                  <el-table-column prop="createUserName" label="申请人" width="90" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="companyName" label="申请公司" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="departmentName" label="申请部门" show-overflow-tooltip> </el-table-column>
                </el-table>

                <h4 style="margin:8px auto; text-align: left;">月度付款金额</h4>
                <el-table :data="getMonthlyRows(props.row.payee)" border size="small" style="max-width: 400px;">
                  <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
                  <el-table-column prop="billMonth" label="月份" width="150" align="center">
                    <template #default="scope">{{ fmtMonth(scope.row.billMonth) }}</template>
                  </el-table-column>
                  <el-table-column prop="monthFee" label="月度付款金额" align="right">
                    <template #default="scope">{{ $util.fmtMoney(scope.row.monthFee) }}</template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="index" label="序号" align="center" width="55"> </el-table-column>
          <el-table-column prop="payee" label="供应商名称(收款方)" min-width="200" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="rankNo" label="排名" width="80" sortable align="center"> </el-table-column>
          <el-table-column prop="feeRate" label="占比" width="90" sortable align="center">
            <template #default="scope">{{ scope.row.feeRate }}%</template>
          </el-table-column>
          <el-table-column prop="billCount" label="单据数" width="90" sortable align="center"> </el-table-column>
          <el-table-column prop="totalFee" label="金额合计" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.totalFee) }}</template>
          </el-table-column>
          <el-table-column prop="paidFee" label="已付款金额" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.paidFee) }}</template>
          </el-table-column>
          <el-table-column prop="unpaidFee" label="未付款金额" width="130" sortable align="right">
            <template #default="scope">{{ $util.fmtMoney(scope.row.unpaidFee) }}</template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ExpenseBillData',
  data() {
    return {
      valueTime: [],
      paramsObj: {
        keyword: '',
        companyId: '',
        departmentId: '',
        payee: '',
        formName: '',
        applyUser: '',
        startDate: '',
        endDate: ''
      },
      formNames: ['请款申请单', '请/借款申请单', '费用报销单'],
      companys: [],
      departments: [],
      supplierData: [],
      detailData: [],
      monthlyData: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      if (!this.showOrgFilters) return '*';
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    companyChange() {
      this.paramsObj.departmentId = '';
      this.departments = [];
      if (this.paramsObj.companyId && this.paramsObj.companyId !== '*') {
        this.$kaung.departments(this.paramsObj.companyId).then(res => { this.departments = res; });
      }
      this.fetch();
    },
    fetch() {
      if (!this.showOrgFilters) {
        this.paramsObj.companyId = '*';
      } else {
        if (!this.companys.length) this.$kaung.companys().then(res => { this.companys = res; });
        if (!this.paramsObj.companyId) this.paramsObj.companyId = this.getDefaultCompanyId();
      }
      if (!this.paramsObj.companyId) {
        this.$message.warning('请选择公司');
        return;
      }
      if ((!this.valueTime || this.valueTime.length != 2) && (!this.paramsObj.startDate || !this.paramsObj.endDate)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.valueTime && this.valueTime.length === 2) {
        this.paramsObj.startDate = this.formatTime(this.valueTime[0]);
        this.paramsObj.endDate = this.formatTime(this.valueTime[1]) + ' 23:59:59';
      }

      request({
        url: '/FundReport/ExpenseBillReport',
        method: 'get',
        params: {
          keyword: this.paramsObj.keyword,
          CompanyID: this.paramsObj.companyId,
          DepartmentID: this.paramsObj.departmentId,
          Payee: this.paramsObj.payee,
          FormName: this.paramsObj.formName,
          ApplyUser: this.paramsObj.applyUser,
          StartDate: this.paramsObj.startDate,
          EndDate: this.paramsObj.endDate
        }
      }).then((res) => {
        this.supplierData = res.data.supplierData || [];
        this.detailData = res.data.detailData || [];
        this.monthlyData = res.data.monthlyData || [];
      });
    },
    getDetailRows(payee) {
      return this.detailData.filter(item => item.payee === payee);
    },
    getMonthlyRows(payee) {
      return this.monthlyData.filter(item => item.payee === payee);
    },
    fmtMonth(month) {
      // yyyy-MM => yyyy年M月
      if (!month) return '';
      const parts = String(month).split('-');
      if (parts.length !== 2) return month;
      return parts[0] + '年' + Number(parts[1]) + '月';
    },
    formatTime(val) { return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate(); }
  },
  mounted() {
    // 初始化默认时间范围（当月）并等待父级触发 fetch
    const range = this.$util.getCurrentDate('month');
    if (range && range.length === 2) {
      this.valueTime = range;
      this.paramsObj.startDate = this.formatTime(range[0]);
      this.paramsObj.endDate = this.formatTime(range[1]) + ' 23:59:59';
    }
  }
}
</script>

<style scoped>
.row-bg {
  margin-bottom: 10px;
}
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}
</style>
